/* Piece Verse customer gallery: opens the photo list dialog (scrolled to the clicked photo), closes on button, backdrop or Esc. */
if (!customElements.get('bk-customer-gallery')) {
  customElements.define(
    'bk-customer-gallery',
    class BkCustomerGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.bk-cg__dialog');
        if (!this.dialog) return;
        this.querySelectorAll('[data-bk-cg-open]').forEach((btn) =>
          btn.addEventListener('click', () => this.open(btn, Number(btn.dataset.bkCgOpen) || 0))
        );
        this.dialog.querySelector('[data-bk-cg-close]')?.addEventListener('click', () => this.dialog.close());
        // A click on the backdrop lands on the dialog element itself.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('overflow-hidden');
          this.opener?.focus();
        });
      }

      open(opener, index) {
        this.opener = opener;
        this.dialog.showModal();
        document.body.classList.add('overflow-hidden');
        const item = this.dialog.querySelector(`[data-bk-cg-index="${index}"]`);
        if (item && index > 0) item.scrollIntoView({ block: 'start' });
        else this.dialog.scrollTop = 0;
      }
    }
  );
}
